<template>
    <v-dialog
        v-model="isDialogOpen"
        persistent
        max-width="300">
        <v-card>
            <v-card-text class="container-discount">
                <h1 class="title-dialog-discount">
                    Aplicar Descuento
                </h1>
                <p class="txt-dialog-discount">
                    Selecciona el descuento:
                </p>

                <v-btn variant="text"
                    class="btn-discount"
                    :class="{ 'btn-discount-active': discount == 5 }"
                    @click="changeDiscount(5)">
                    <span>5%</span>
                </v-btn>

                <v-btn variant="text"
                    class="btn-discount"
                    :class="{ 'btn-discount-active': discount == 10 }"
                    @click="changeDiscount(10)">
                    <span>10%</span>
                </v-btn>

                <v-btn variant="text"
                    class="btn-discount"
                    :class="{ 'btn-discount-active': discount == 15 }"
                    @click="changeDiscount(15)">
                    <span>15%</span>
                </v-btn>

                <v-btn variant="text"
                    class="btn-discount"
                    :class="{ 'btn-discount-active': discount == 20 }"
                    @click="changeDiscount(20)">
                    <span>20%</span>
                </v-btn>

            </v-card-text>
            <v-card-actions class="container-discount" >

                <v-btn variant="text"
                    class="btn-discount-Ok"
                    :disabled="isDisable"
                    @click="okBtn">
                    <span>Aplicar descuento</span>
                </v-btn>

                 <v-btn
                    class="btn-dialog-discount"
                    color="#FF5700"
                    @click="isDialogOpen = false">
                    Cerrar sin cambios
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
  name: 'CommerciaVueDialogDiscount',
  emits: ['okBtn'],
  data () {
    return {
      isDialogOpen: false,
      discount: 0
    }
  },
  computed: {
    isDisable () {
      return this.discount === 0
    }
  },
  methods: {

    open () {
      this.discount = 0
      this.isDialogOpen = true
    },
    changeDiscount (value) {
      this.discount = value
    },
    okBtn () {
      this.$emit('okBtn', this.discount)
      this.isDialogOpen = false
    }
  }
}
</script>
<style scoped>
    .title-dialog-discount{
        width: 100%;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .txt-dialog-discount{
        width: 100%;
        font-size: 16px;
    }
    .btn-dialog-discount{
        width: 100%;
    }
    .btn-discount{
        background-color: #BFC0D1;
        color: #222222;
        margin-top: 20px;
    }
    .btn-discount-active{
        background-color: #FB925A !important;
        color: #F9F6F2 !important;
    }

    .btn-discount-Ok{
        background-color: #FF5700 ;
        color: #F9F6F2 ;
        margin-bottom: 20px;
    }
    .container-discount{
        display: flex;
        flex-direction: column;
    }
</style>
